import { translationCountries } from "../../constants/countries"

export const isCurrentPageALocale = (page: string): boolean => {
  return translationCountries.some(({ pathPrefix }) => {
    return page === pathPrefix + "/"
  })
}
